module.exports = __webpack_public_path__ + "img/corporate3.138f4856.png";